import React from 'react';
import PropTypes from 'prop-types';
import { Route, Switch, withRouter } from 'react-router-dom';
import Sidebar from 'react-sidebar';
import { StateContext } from '../../State';
import Menu from '../../Components/Menu/Menu';
import MenuButton from '../../Components/MenuButton/MenuButton';
import Title from '../../Components/Title/Title';
import History from '../../Pages/History/History';
import Clients from '../../Pages/Clients/Clients';
import Technical from '../../Pages/Technical/Technical';
import Customer from '../../Pages/Customer/Customer';
import Forms from '../../Pages/Forms/Forms';
import Draft from '../../Pages/Draft/Draft';
import Installation from '../../Pages/Installation/Installation';
import Phases from '../../Pages/Phases/Phases';
import Register from '../../Pages/Register/Register';
import InstallationRegister from '../../Pages/InstallationRegister/InstallationRegister';


import Sections from '../../Pages/Forms/Sections';
import Fields from '../../Pages/Forms/Fields';
import Form from '../../Pages/Form/Form';
import menuAdmin from './data/dataMenuAdmin';
import menuTechnical from './data/dataMenuOp';
import menuCustomer from './data/dataMenuClient';

import avatar from './avatar.png';

import './Main.scss';

const mql = window.matchMedia('(min-width: 800px)');

class Main extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            docked: mql.matches,
            transitions: false,
            dataMenu: [],
            username: '',
        };

        this.menuButtonClick = this.menuButtonClick.bind(this);
        this.mediaQueryChanged = this.mediaQueryChanged.bind(this);
        this.checkLoggedIn = this.checkLoggedIn.bind(this);
        this.findTitle = this.findTitle.bind(this);
    }

    componentDidMount() {
        mql.addListener(this.mediaQueryChanged);
        this.findTitle();
        this.checkLoggedIn();
    }

    componentWillUnmount() {
        mql.removeListener(this.mediaQueryChanged);
    }

    mediaQueryChanged() {
        this.setState({
            docked: mql.matches,
        });
    }

    checkLoggedIn() {
        const [{ role, user }, dispatch] = this.context;
        if (role.name === undefined) {
            dispatch({
                type: 'LOAD_SESSION',
            });
        } else {
            switch (role.name) {
                case 'administrator':
                    this.setState({
                        dataMenu: menuAdmin,
                        username: `${user.name} ${user.last_name}`,
                        role: `${role.name}`,
                    });
                    break;
                case 'customer':
                    this.setState({
                        dataMenu: menuCustomer,
                        username: `${user.name} ${user.last_name}`,
                        role: `${role.name}`,
                    });
                    break;
                default:
                    this.setState({
                        dataMenu: menuTechnical,
                        username: `${user.name} ${user.last_name}`,
                        role: `${role.name}`,
                    });
            }
        }
    }

    findTitle() {
        const { location } = this.props;
        const { pathname } = location;
        const { dataMenu } = this.state;

        const item = dataMenu.find((v) => v.path === pathname);
        document.title = item ? `Feel Secure | ${item.title}` : 'Feel Secure';
        return item ? item.title : '';
    }

    menuButtonClick(event) {
        event.preventDefault();
        const { docked } = this.state;
        this.setState({
            transitions: true,
            docked: !docked,
        });
    }

    render() {
        const {
            docked, transitions, dataMenu, username, role,
        } = this.state;

        const sidebarProps = {
            sidebar: <Menu items={dataMenu} username={username} avatar={avatar} role={role} />,
            docked,
            shadow: false,
            transitions,
        };

        return (
            <Sidebar {...sidebarProps}>
                <div className="top-area">
                    <MenuButton onClick={this.menuButtonClick} />
                    <Title text={this.findTitle()} />
                </div>
                <div className="content-area">
                    <Switch>
                        <Route exact path="/admin/dashboard" component={History} />
                        <Route exact path="/admin/clientes" component={Clients} />
                        <Route exact path="/admin/municipalidad" component={Customer} />
                        <Route exact path="/admin/tecnicos" component={Technical} />
                        <Route exact path="/admin/formularios" component={Forms} />
                        <Route exact path="/admin/borrador" component={Draft} />
                        <Route exact path="/admin/formularios/:id" component={Sections} />
                        <Route exact path="/admin/formularios/secciones/:id" component={Fields} />
                        <Route exact path="/admin/instalacion" component={Installation} />
                        <Route exact path="/admin/etapas" component={Phases} />
                        <Route exact path="/admin/entrada" component={Form} />
                        <Route exact path="/registros" component={Register} />
                        <Route exact path="/registros/:id" component={InstallationRegister} />
                    </Switch>
                </div>
            </Sidebar>
        );
    }
}

Main.contextType = StateContext;

Main.propTypes = {
    location: PropTypes.shape({
        pathname: PropTypes.string.isRequired,
    }),
};

Main.defaultProps = {
    location: {
        pathname: '',
    },
};

export default withRouter(Main);
